import React from 'react';
import PropTypes from 'prop-types';

import ConfirmationDialog from 'components/ConfirmationDialog';
import messages from '../messages';

const getSubHeading = (isSamePhotographer, isLastPhotographerReschedule) => {
  if (!isSamePhotographer) {
    return messages.differentPhotographerSelected;
  }
  if (isLastPhotographerReschedule) {
    return messages.lastRescheduleSamePhotographerSelected;
  }
  return messages.samePhotographerSelected;
};

export const SuccessfulRescheduleDialog = ({
  isSamePhotographer,
  isLastPhotographerReschedule,
  isDialogLoading,
  onConfirmationAction,
  onCancelAction,
  isDialogOpen,
}) => {
  const subHeading = getSubHeading(isSamePhotographer, isLastPhotographerReschedule);

  return (
    <ConfirmationDialog
      open={isDialogOpen}
      onCancel={onCancelAction}
      subHeading={subHeading}
      isDialogLoading={isDialogLoading}
      confirmationTitle={messages.successfulRescheduling}
      confirmationDescription={
        isSamePhotographer
          ? messages.samePhotographerDescription
          : messages.differentPhotographerDescription
      }
      confirmationButtonText={messages.gotIt}
      confirmationAction={onConfirmationAction}
    />
  );
};

SuccessfulRescheduleDialog.propTypes = {
  isSamePhotographer: PropTypes.bool.isRequired,
  isLastPhotographerReschedule: PropTypes.bool,
  isDialogLoading: PropTypes.bool.isRequired,
  onConfirmationAction: PropTypes.func.isRequired,
  onCancelAction: PropTypes.func.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
};

SuccessfulRescheduleDialog.defaultProps = {
  isLastPhotographerReschedule: false,
};

